import type { AllRouteEndpoints } from "../routeTypes";
export const appsAppGroupIdEmailSettingsCacheKeys: AllRouteEndpoints[] = [
  "/apps/:app_group_id/settings",
  "/engagement/:app_group_id/email_settings",
  "/engagement/:app_group_id/list_email_settings",
];
